const UsePermissionsClaim = () => {
  const permissions = (() => {
    try {
      const stored = localStorage.getItem("perms");
      if (!stored) return [];

      // convert "a,b,c" → ["a", "b", "c"]
      return stored.split(",").map((p) => p.trim());
    } catch {
      return [];
    }
  })();

  // Check permission
  const checkPermission = (permission) => {
    return permissions.includes(permission);
  };

  return { checkPermission, permissions };
};

export default UsePermissionsClaim;
